import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 8px 0px;
`;

export const Title = styled.span`
  font-size: 14px;
  font-weight: 500;
`;
